import { isBrowser } from '@axo/shared/util/dom';
import { CrossDomainAuthData } from '../CrossDomainAuth.types';
import { StorageKeys } from '../StorageKeys';

export const retrieveCrossDomainAuth = (): CrossDomainAuthData => {
  if (!isBrowser()) return { applicationId: undefined, token: undefined };

  const applicationId = sessionStorage.getItem(StorageKeys.AppId) || undefined;
  const token = sessionStorage.getItem(StorageKeys.Token) || undefined;
  return { applicationId, token };
};
